<p>payment-promo-qr works!</p>
